import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AdminView from "./AdminView"; // AdminView statt AdminLogin importieren
import ViewerView from "./ViewerView";

function App() {
  return (
    <Router>
      <Routes>
        {/* AdminView wird gerendert */}
        <Route path="/admin" element={<AdminView />} />
        <Route path="/" element={<ViewerView />} />
      </Routes>
    </Router>
  );
}

export default App;